import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoInternetGuard implements CanActivate {

  constructor(private http: HttpClient, private router: Router) {}

  canActivate() {
    return this.http.get(`${environment.uriG}/health`).pipe(
      map(() => {
        // Internet is available - redirect to dashboard
        this.router.navigate(['/dashboards/analytics']);
        return false; // Prevent access to offline route
      }),
      catchError(() => {
        // Internet not available - allow access to offline route
        console.warn("No internet connection - staying offline");
        return of(true);
      })
    );
  }
}
